<template lang="pug">
  div.alert-main
    div
      p ログアウトしますか？
      ul
        li
          button.btnNo(@click="no") いいえ
        li
          button.btnYes(@click="yes") はい
</template>

<script>
import router from '../../router';
export default{
  name: 'ModalAlert',
  data () {
    return {
      base: ''
    };
  },
  props: {
  },
  methods: {
    yes () {
      this.$emit('close', 'yes');
    },
    no () {
      this.$emit('close', 'no');
    }
  },
  created () {
  },
  mounted () {
    document.querySelector('body').appendChild(this.$el.parentNode.parentNode);
    this.base = router.options.base;
  }
};
</script>

<style lang="stylus" scoped>
  .alert
    .alert-main
      position absolute
      left 0
      right 0
      top 0
      bottom 0
      display flex
      justify-content center
      align-items center
    p
      margin-bottom 20px
      text-align center
      font-size 14px
    ul
      display flex
      justify-content center
      .btnNo
        width 130px
        height 33px
        border 1px solid #2E7B80
        color #2E7B80
        border-radius 3px
        background-color #ffffff
        font-size 12px
        font-weight bold
        margin-left 15px
      .btnYes
        width 130px
        height 33px
        border 1px solid #2E7B80
        color #FFFFFF
        border-radius 3px
        background-color #2E7B80
        font-size 12px
        font-weight bold
        margin-left 15px
</style>



// WEBPACK FOOTER //
// src/components/parts/ModalAlert.vue